export default {"src":"/_next/static/media/logo.c3fb58a1.svg","height":46,"width":22,"blurWidth":0,"blurHeight":0};